var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgContinuousSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9867 0.666667C6.62666 0.666667 0.666664 6.64 0.666664 14C0.666664 21.36 6.62666 27.3333 13.9867 27.3333C21.36 27.3333 27.3333 21.36 27.3333 14C27.3333 6.64 21.36 0.666667 13.9867 0.666667ZM14 24.6667C8.10666 24.6667 3.33333 19.8933 3.33333 14C3.33333 8.10667 8.10666 3.33333 14 3.33333C19.8933 3.33333 24.6667 8.10667 24.6667 14C24.6667 19.8933 19.8933 24.6667 14 24.6667ZM14.6667 7.33333H12.6667V15.3333L19.6667 19.5333L20.6667 17.8933L14.6667 14.3333V7.33333Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContinuousSchedule);
export default __webpack_public_path__ + "97120/static/media/ContinuousSchedule.aeb6b7ae89b33f5dd72a32a1993b0033.svg";
export { ForwardRef as ReactComponent };